export default "__VITE_ASSET__CCQRd_9G__"